import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/lab-procedures/inr";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	inr: {
		id: "form.inr",
		defaultMessage: "INR"
	},
	value: {
		id: "form.inr.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "inr",
	value: {
		title: messages.inr,
		validator,
		fieldset,
		isImportant: true
	}
};
